import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import PropTypes from "prop-types";

/* -------- Protected -------- */

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
};

/* -------- Unprotected -------- */

export const UnProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

UnProtectedRoute.propTypes = {
  children: PropTypes.node,
};

/* -------- Role-based -------- */

export const RolesAuthRoute = ({ children, roles }) => {
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!roles?.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

RolesAuthRoute.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.array,
};

/* -------- Channel-based -------- */

export const ChannelAuthRoute = ({ children, channel }) => {
  const { isAuthenticated, isAdmin, channels } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!channel || isAdmin) {
    return children;
  }

  const requiredChannels = Array.isArray(channel) ? channel : [channel];

  const hasAccess = requiredChannels.some((c) => channels.includes(c));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

ChannelAuthRoute.propTypes = {
  children: PropTypes.node,
  channel: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
